import { gql } from "@apollo/client";

export const GET_AAU_ROUTE_DAILY = gql`
  query GetAauRouteDaily($startDay: date!) {
    v_aau_route_daily(
      where: { day: { _gte: $startDay } }
      order_by: { day: desc }
    ) {
      day
      route_id
      route_label
      path
      event_type
      event_count
      unique_users
      unique_orgs
    }
  }
`;

export const GET_AAU_USER_DAILY = gql`
  query GetAauUserDaily($startDay: date!) {
    v_aau_user_daily(
      where: { day: { _gte: $startDay } }
      order_by: { day: desc }
    ) {
      day
      user_id
      username
      event_count
      unique_routes
    }
  }
`;

export const GET_AAU_ORG_DAILY = gql`
  query GetAauOrgDaily($startDay: date!) {
    v_aau_org_daily(
      where: { day: { _gte: $startDay } }
      order_by: { day: desc }
    ) {
      day
      organization_id
      organization_name
      event_count
      unique_users
    }
  }
`;

export const GET_AAU_RECENT_ERRORS = gql`
  query GetAauRecentErrors($startAt: timestamptz!, $limit: Int!) {
    admin_analytics_events(
      where: {
        event_type: { _eq: "error_shown" }
        viewed_at: { _gte: $startAt }
      }
      order_by: { viewed_at: desc }
      limit: $limit
    ) {
      id
      viewed_at
      route_id
      route_label
      path
      user_id
      organization_id
      error_code
      payload
    }
  }
`;
